<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
  </cTable>
</template>

<script>
import {
  getLocation,
  getSku,
  createBill,
  uploadFixedStock,
} from "@/api/analysis/location";
import { getAllClient } from "@/api/user/client";
import cTable from "@/base/common/index";
import { getWarehouse } from "@/api/storage/warehouse";
export default {
  name: "report_location ",
  components: {
    cTable,
  },
  data() {
    return {
      methods: {
        list: (p) => getLocation(p),
        getAllClient,
        getWarehouse,
        getSku,
        createBill,
        uploadFixedStock,
        beforeHandleList({ data }) {
          !this.pushTableTitle &&
            data.rows[0].warehouse.forEach((item, index) => {
              this.pushTableTitle = true;
              let obj = {
                name: item.title,
                children: [
                  {
                    name: () => this.$t("location_t") + this.$t("quantity_num"),
                    key: "num",
                    minWidth: 100,
                    methods: {
                      render({ row }) {
                        return row.warehouse[index].num.toString();
                      },
                    },
                  },
                  {
                    name: () => this.$t("location_t") + this.$t("doublePrice"),
                    key: "num_price",
                    minWidth: 100,
                    methods: {
                      render({ row }) {
                        return row.warehouse[index].num_price.toString();
                      },
                    },
                  },
                  {
                    name: () => this.$t("location_t") + this.$t("reChAmount"),
                    key: "num_fee",
                    minWidth: 100,
                    methods: {
                      render({ row }) {
                        return row.warehouse[index].num_fee.toString();
                      },
                    },
                  },
                  {
                    name: () => "SKU" + this.$t("skuVolume"),
                    key: "volume",
                    minWidth: 100,
                    methods: {
                      render({ row }) {
                        return row.warehouse[index].volume.toString();
                      },
                    },
                  },
                  {
                    name: () =>
                      "SKU" + this.$t("skuVolume") + this.$t("doublePrice"),
                    key: "volume_price",
                    minWidth: 120,
                    methods: {
                      render({ row }) {
                        return row.warehouse[index].volume_price.toString();
                      },
                    },
                  },
                  {
                    name: () =>
                      "SKU" + this.$t("skuVolume") + this.$t("reChAmount"),
                    key: "volume_fee",
                    minWidth: 120,
                    methods: {
                      render({ row }) {
                        return row.warehouse[index].volume_fee.toString();
                      },
                    },
                  },
                  {
                    name: () => this.$t("total") + this.$t("reChAmount"),
                    key: "total_fee",
                    minWidth: 100,
                    methods: {
                      render({ row }) {
                        return row.warehouse[index].total_fee.toString();
                      },
                    },
                  },
                ],
              };
              this.fields.push(obj);
            });
          return;
        },
      },
      config: {
        height: 630,
      },
      modals: {
        showSku: {
          footer: {
            show() {
              return false;
            },
          },
          config: {
            listFn: "getSku",
            modalBind: {
              width: 1000,
              draggable: true,
              maskClosable: true,
            },
          },
          table: {
            header: {
              config: {
                custom: false,
              },
              searchs: [
                {
                  key: "month",
                  component: "DatePicker",
                  placeholder() {
                    return (
                      this.$t("select") + this.$t("start") + this.$t("date")
                    );
                  },
                  bind: {
                    type: "month",
                    style: {
                      width: "150px",
                    },
                  },
                  default: () => {
                    let date = new Date();
                    date.setMonth(date.getMonth() - 1);
                    return date;
                  },
                  methods: {
                    format({ value, newFormData }) {
                      newFormData.temp = 1;
                      return value
                        ? this.format.monthFormat(value, "YYYY-MM")
                        : "";
                    },
                  },
                },
              ],
              btns: {
                list: [
                  // {
                  //   name: this.$t("analysis1"),
                  //   type: "add",
                  //   fnName: "add",
                  //   bind: {
                  //     type: "warning"
                  //   }
                  // },
                  {
                    name: this.$t("export"),
                    type: "export",
                    fnName: "export",
                    bind: {
                      icon: "md-arrow-down",
                      type: "primary",
                    },
                  },
                ],
                methods: {
                  export({ searchForm }) {
                    let data = JSON.parse(JSON.stringify(searchForm));
                    data.export = 1;
                    data.month = this.format.monthFormat(
                      searchForm.month,
                      "YYYY-MM"
                    );
                    data.client_id =
                      this.getModal("showSku").pageConfig.data.client_id;
                    this.getModal("showSku").openLoading();
                    this.handleRequestMethods("getSku", data).then((res) => {
                      this.getModal("showSku").closeLoading();
                      window.open(this.$globalUrl + res.payload.src);
                    });
                  },
                },
              },
            },
            config: {
              height: 600,
            },
            footer: {
              show() {
                return true;
              },
            },
            fields: [
              {
                name: () => this.$t("warehouseName"),
                key: "title",
                width: 150,
              },
              {
                name: () => this.$t("location_t"),
                key: "location",
                align: "left",
                minWidth: 150,
              },
              {
                name: () => this.$t("skuName"),
                key: "sku_name",
                align: "left",
                minWidth: 150,
              },
              {
                name: () => "SKU",
                key: "sku",
                align: "left",
                minWidth: 150,
              },
              {
                name: () => this.$tz("数量"),
                key: "quantity",
                minWidth: 150,
              },
              {
                name: () => this.$t("charge_volume"),
                key: "volume_weight",
                minWidth: 150,
              },
            ],
          },
        },
      },
      header: {
        searchs: [
          {
            key: "month",
            component: "DatePicker",
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("date");
            },
            bind: {
              type: "month",
              style: {
                width: "150px",
              },
            },
            default: () => {
              let date = new Date();
              date.setMonth(date.getMonth() - 1);
              return date;
            },
            methods: {
              format({ value, newFormData }) {
                newFormData.temp = 1;
                return value ? this.format.monthFormat(value, "YYYY-MM") : "";
              },
            },
          },
          {
            key: "warehouse_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("warehouseName");
            },
            clearable: true,
            options: [],
            config: { label: "title", value: "id" },
            bind: {
              style: "width:150px",
            },
          },
          {
            key: "client_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            clearable: true,
            options: [],
            config: { label: "account", value: "id" },
            bind: {
              style: "width:150px",
            },
          },
          // {
          //   key: "channelCode",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("channel_name");
          //   },
          //   clearable: true,
          //   options: [],
          //   config: {
          //     label({ row }) {
          //       return row.channel_name + "-" + row.channel_code;
          //     },
          //     value: "channel_code"
          //   },
          //   bind: {
          //     style: "width:150px"
          //   }
          // },
          // {
          //   key: "codType",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("cod_type");
          //   },
          //   clearable: true,
          //   options: [
          //     { label: "NCND", value: "NCND" },
          //     {
          //       label: "NOR",
          //       value: "NOR"
          //     }
          //   ],
          //   bind: {
          //     style: "width:150px"
          //   }
          // },
          // {
          //   key: "deliver",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + "地派";
          //   },
          //   clearable: true,
          //   options: [],
          //   config: { label: "agent_name", value: "agent_name" },
          //   bind: {
          //     style: "width:140px"
          //   }
          // },
          // {
          //   key: "noUpdateDay",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + "无更新天数";
          //   },
          //   clearable: true,
          //   options: [],
          //   // config: { label: "agent_name", value: "agent_name" },
          //   bind: {
          //     style: "width:140px"
          //   }
          // },
          // {
          //   key: "trackerStatus",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("tracker_code");
          //   },
          //   clearable: true,
          //   options: [],
          //   config: { label: "tracker_code", value: "tracker_code" },
          //   bind: {
          //     style: "width:140px"
          //   }
          // },
          // {
          //   key: "keywords",
          //   placeholder() {
          //     return this.$t("keyword");
          //   },
          //   bind: {
          //     style: "width:140px",
          //     type: "textarea",
          //     rows: 1
          //   },
          //   component: "Input"
          // }
        ],
        btns: {
          list: [
            {
              name: this.$t("generateBill"),
              type: "generate",
              fnName: "generateFun",
              bind: {
                type: "warning",
              },
              id: 962,
            },
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
            {
              name: () => this.$t("uploadLocationInfo"),
              type: "upload",
              fnName: "upload",
              component: "Upload",
              bind: {
                type: "primary",
                showUploadList: false,
              },
            },
            {
              name: () => this.$t("downloadLocationInfo"),
              type: "down",
              fnName: "down",
              bind: {
                type: "primary",
              },
            },
          ],
          methods: {
            down() {
              window.open(
                this.$globalUrl +
                  "/doc/lang/fixedStockTpl.xlsx".replace(
                    "lang",
                    this.$i18n.locale
                  )
              );
            },
            generateFun({ searchForm }) {
              this.$Modal.confirm({
                title: this.$t("generateBill"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  let data = JSON.parse(JSON.stringify(searchForm));
                  this.handleRequestMethods("createBill", data, true, true);
                },
              });
            },
            export({ searchForm }) {
              let data = JSON.parse(JSON.stringify(searchForm));
              data.export = 1;
              data.month = this.format.monthFormat(searchForm.month, "YYYY-MM");
              this.handleRequestMethods("list", data, false, true).then(
                (res) => {
                  window.open(this.$globalUrl + res.payload.src);
                }
              );
            },
            upload({ file }) {
              this.$page
                .readFile(file)
                .then((res) => {
                  let keys = [
                    "date",
                    "client",
                    "warehouse",
                    "quantity",
                    "volume_weight",
                  ];
                  let data = res.map((item) => {
                    return Object.values(item).reduce((a, b, i) => {
                      a[keys[i]] = b;
                      return a;
                    }, {});
                  });
                  this.$page
                    .handleRequestMethods(
                      "uploadFixedStock",
                      { data },
                      true,
                      true
                    )
                    .then((res) => {
                      this.$page.getList();
                    });
                })
                .catch((err) => {
                  console.log(err);
                });
              return false;
            },
          },
        },
      },
      fields: [
        {
          name: () => this.$t("account"),
          key: "account",
          align: "left",
          minWidth: 130,
        },
        {
          name: () => this.$t("company_name"),
          align: "left",
          key: "company",
          minWidth: 130,
        },
        {
          name: () => this.$t("contract_title"),
          align: "left",
          key: "contract",
          minWidth: 130,
        },
        {
          type: "btns",

          minWidth: 100,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => "SKU" + this.$t("report"),
              type: "showSku",
              fnName: "showSku",
              bind: {
                type: "warning",
              },
            },
          ],
          methods: {
            showSku({ row }) {
              this.getModal("showSku").open({}, function () {
                this.pageConfig.data = { client_id: row.client_id };
                this.getList();
                this.setTitle(row.account + "(SKU" + this.$t("report") + ")");
              });
            },
          },
        },
      ],
    };
  },
  mounted() {
    this.header.searchs.forEach(async (item) => {
      if (item.key === "client_id")
        item.options = (await getAllClient()).data.payload.rows;
      if (item.key === "warehouse_id")
        item.options = (await getWarehouse()).data.payload.rows;
    });
  },
};
</script>
